import React from 'react'
import { addToast, ToastContent } from '@mobi/component-library/Feedback/Toast'
import { useMutation } from '@tanstack/react-query'
import { patchSplitBonusBet } from '../data/api'
import { fetchCampaignsAsync } from '@core/State/UserAccount/async-signals'

type UseSplitBonusBetMutationProps = {
  updateBonusBetToSplit: () => void
}

export const useSplitBonusBetMutation = ({
  updateBonusBetToSplit,
}: UseSplitBonusBetMutationProps) => {
  return useMutation({
    mutationFn: ({ bonusBetId, numberOfTokens }: { bonusBetId: number; numberOfTokens: number }) =>
      patchSplitBonusBet(bonusBetId, numberOfTokens),

    onSuccess: () => {
      fetchCampaignsAsync()
      updateBonusBetToSplit()
      addToast({
        id: 'bet-split-success',
        isDismissable: true,
        timeoutMs: 5000,
        content: <ToastContent title='Bonus Bet has been split successfully' />,
      })
    },

    onError: () => {
      updateBonusBetToSplit()
      addToast({
        id: 'bet-split-failure',
        isDismissable: true,
        timeoutMs: 5000,
        content: <ToastContent title='Failed to split Bonus Bet' />,
      })
    },
  })
}
